/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ExamId202,
  DeleteApiV1ExamId400,
  DeleteApiV1ExamId401,
  DeleteApiV1ExamId404,
  DeleteApiV1ExamId500,
  DeleteApiV1ExamIdMutationResponse,
  DeleteApiV1ExamIdPathParams,
} from "../../types/examEvaluationController/DeleteApiV1ExamId.ts";

export const deleteApiV1ExamIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ExamIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ExamId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ExamId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ExamId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ExamId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ExamId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ExamId500>;

export const deleteApiV1ExamIdMutationResponseSchema = z.lazy(
  () => deleteApiV1ExamId202Schema,
) as unknown as ToZod<DeleteApiV1ExamIdMutationResponse>;
